import { tool, zodSchema } from 'ai';
import { z } from 'zod';
import type { AiTool } from '@erikdakoda/ai-tool/types';
import { botsToolGroupIcon } from './toolGroupIcon';
import { ItemForTrashSchema } from '@erikdakoda/ai-tool/ItemForTrash';

export const trashBotInputSchema = z.object({
  action: z
    .enum(['trash', 'restore'])
    .describe('Trash soft-deletes the bot; restore undoes trash.'),
  botId: z.string(),
});

export const trashBotOutputSchema = z.object({
  queryArgs: z.object({
    where: z.object({ id: z.string() }),
    data: ItemForTrashSchema.omit({ id: true }),
  }),
  queryResult: ItemForTrashSchema.nullable()
    .optional()
    .describe('The trashed or restored item; null if not found.'),
  error: z.unknown().nullable(),
});

export type TrashBotInput = z.infer<typeof trashBotInputSchema>;
export type TrashBotOutput = z.infer<typeof trashBotOutputSchema>;

export const trashBot: AiTool<undefined, TrashBotInput, TrashBotOutput> = {
  id: 'trashBot',

  group: 'bots',

  ...botsToolGroupIcon,

  userSelect: false,

  access: 'WRITE',

  tool: tool({
    description: 'Soft-delete a bot (trash) or restore it from trash.',
    inputSchema: zodSchema(trashBotInputSchema),
    outputSchema: zodSchema(trashBotOutputSchema),
  }),
};
